export const stripeKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY
export const backendHost =
    process.env.REACT_APP_API_ENDPOINT || "https://api.shoutbase.com"
export const stripeSoloPlanId = process.env.REACT_APP_STRIPE_SOLO_PLAN_ID
export const stripeTeamPlanId = process.env.REACT_APP_STRIPE_TEAM_PLAN_ID



// WEBPACK FOOTER //
// ./src/util/environment_utils.js